import { Button, Card, InputAdornment, Stack, TextField } from "@mui/material";
import CustomBreadcrumbs from "../../../components/custom-breadcrumbs/custom-breadcrumbs";
import PageComponent from "../../../components/page";
import Iconify from "../../../components/iconify";
import SortByComponent from "../../../components/sort-by-component";
import TableComponent from "../../../components/table";
import { ChangeEvent } from "react";
import { IUser } from "../../../types/user";
import UserTableRow from "../components/table-row";
import useUserList from "./useList";
import { columnsTable, userOrderOptions } from "../../../constants/user";
import { useRouter } from "../../../routes/hooks";

const UsersPage = () => {

    const router = useRouter();
    const { name, setName, loading, table, getUsers, usersList, deleteUser, activeUser } = useUserList();

    return (
        <PageComponent>
            <>
                <CustomBreadcrumbs
                    heading="Usuários"
                    links={[
                        {
                            name: "Usuários"
                        },
                        {
                            name: "Lista"
                        }
                    ]}
                    action={
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon={'mingcute:add-line'} />}
                            onClick={() => router.push('/users/create')}
                        >
                            Novo Usuário
                        </Button>
                    }
                    sx={{ mb: { xs: 3, md: 5 } }}
                />
                <Stack
                    spacing={3}
                    justifyContent={'space-between'}
                    alignItems={{ xs: 'flex-end', md: 'center' }}
                    direction={{ xs: 'column', md: 'row' }}
                    sx={{ mb: { xs: 3, md: 5 } }}
                >
                    <TextField
                        placeholder="Pesquisar..."
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Iconify icon={"eva:search-fill"} sx={{ ml: 1, color: 'text.disabled' }} />
                                </InputAdornment>
                            )
                        }}
                        sx={{ width: { xs: 1, md: 260 } }}
                        value={name}
                        onChange={(event: ChangeEvent<HTMLInputElement>) => setName(event.target.value)}
                    />

                    <SortByComponent
                        direction={table.direction}
                        sortBy={table.sortBy}
                        onSort={table.onSort}
                        sortOptions={userOrderOptions}
                    />
                </Stack>

                <Card>
                    <TableComponent
                        table={table}
                        headLabel={columnsTable}
                        totalCount={usersList?.totalCount ?? 0}
                        loading={loading.value}
                    >
                        <>
                            {
                                usersList?.data.map((user: IUser) => {
                                    return (
                                        <UserTableRow
                                            key={user.id}
                                            row={user}
                                            onDeleteRow={(id: number) => user.deletedAt ? activeUser(id) : deleteUser(id)}
                                        />
                                    )
                                })
                            }
                        </>
                    </TableComponent>
                </Card>
            </>
        </PageComponent>
    );

};

export default UsersPage;